module.exports = __webpack_public_path__ + "static/media/bursts_07.ff950554.svg";